import { LoginContainer } from './LoginContainer';

const name = 'LoginContainer';

export { name, LoginContainer };
